const constants = require('@/util/constants')
require('./config')

/**
 * 获取排队访客
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
// export function queryQueues (successcb, failedcb) {
//   axios.get('/api/queue/query', {
//     params: {
//       'client': constants.HTTP_CLIENT
//     }
//   }).then(response => {
//     successcb(response.data)
//   }).catch(error => {
//     failedcb(error)
//   })
// }

/**
 * 获取排队访客
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function queryQueues(page, size, successcb, failedcb) {
  axios.get('/api/v2/queue/get', {
    params: {
      'page': page,
      'size': size,
      'client': constants.HTTP_CLIENT
    }
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

/**
 * 接入排队访客
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function acceptQueue (qid, successcb, failedcb) {
  axios.post('/api/v2/queue/accept', {
    qid: qid,
    client: constants.HTTP_CLIENT
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

/**
 * 忽略排队访客
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function ignoreQueue(qid, successcb, failedcb) {
  axios.post('/api/v2/queue/ignore', {
    qid: qid,
    client: constants.HTTP_CLIENT
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}
